import React from "react";
import {
  Box, Typography, Button, Paper, List, ListItem, ListItemText, ListItemIcon,
  Grid, Autocomplete, TextField, Checkbox, FormControlLabel, Switch,
  Collapse, useTheme, CircularProgress, Fade, Radio,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import DocumentAutocompleteClone from "./DocumentAutocompleteClone";

const FlexibleTab = ({
  token,
  idDocument,
  originSections,
  isNoteMode,
  setIsNoteMode,
  expandedSection,
  setExpandedSection,
  notes,
  loadingNotes,
  selectedNotes,
  onToggleNote,
  selectedSectionOrigin,
  setSelectedSectionOrigin,
  targetId,
  setTargetId,
  targetName,
  setTargetName,
  targetSectionId,
  setTargetSectionId,
  destinationSections,
  loadingDestSections,
  onConfirm,
  loadingFlex,
  loadingMassive,
}) => {
  const theme = useTheme();

  const isConfirmDisabled =
    !targetId ||
    !targetSectionId ||
    (isNoteMode
      ? selectedNotes.length === 0 || !expandedSection
      : !selectedSectionOrigin) ||
    loadingFlex ||
    loadingMassive;

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={8}>
        <Box sx={{ mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 600 }}>Selección de Origen</Typography>
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={isNoteMode}
                onChange={(e) => setIsNoteMode(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                MODO NOTAS
              </Typography>
            }
          />
        </Box>

        <Paper elevation={0} sx={{
          border: "1px solid", borderColor: theme.palette.divider,
          borderRadius: 3, bgcolor: "background.paper"
        }}>
          <List disablePadding>
            {originSections?.map((section) => (
              <React.Fragment key={section.ID_SECCION}>
                <ListItem divider sx={{ borderColor: theme.palette.divider }}>
                  <ListItemIcon
                    onClick={() =>
                      isNoteMode &&
                      setExpandedSection(
                        expandedSection === section.ID_SECCION ? null : section.ID_SECCION
                      )
                    }
                    sx={{ cursor: "pointer" }}
                  >
                    {isNoteMode ? (
                      expandedSection === section.ID_SECCION ? (
                        <KeyboardArrowUp color="primary" />
                      ) : (
                        <KeyboardArrowDown />
                      )
                    ) : (
                      <Radio
                        checked={selectedSectionOrigin === section.ID_SECCION}
                        onChange={() => setSelectedSectionOrigin(section.ID_SECCION)}
                        size="small"
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={section.NOMBRE_SECCION} />
                </ListItem>

                <Collapse in={expandedSection === section.ID_SECCION && isNoteMode}>
                  <Box sx={{ pl: 4, bgcolor: "action.hover", borderBottom: "1px solid #eee" }}>
                    {loadingNotes ? (
                      <Typography sx={{ p: 2, fontSize: "0.8rem" }}>Cargando notas...</Typography>
                    ) : (
                      (notes || []).map((nota) => {
                        const currentId = Number(nota.id_sintesis || nota.ID_SINTESIS);
                        return (
                          <ListItem key={currentId} button onClick={() => onToggleNote(nota)}>
                            <ListItemIcon>
                              <Checkbox checked={selectedNotes.includes(currentId)} size="small" />
                            </ListItemIcon>
                            <ListItemText
                              primary={nota.titulo}
                              secondary={`ID Síntesis: ${currentId}`}
                            />
                          </ListItem>
                        );
                      })
                    )}
                  </Box>
                </Collapse>
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Grid>

      <Grid item xs={12} md={4}>
        <Paper elevation={0} sx={{
          p: 3, borderRadius: 3, border: "1px solid", borderColor: theme.palette.divider,
          bgcolor: "background.paper", position: "sticky", top: 20
        }}>
          <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 700 }}>
            CONFIGURACIÓN DESTINO
          </Typography>

          <DocumentAutocompleteClone
            token={token}
            documentID={targetId}
            setDocumentID={setTargetId}
            setNameDocument={setTargetName}
            excludeId={idDocument}
          />

          {targetId && (
            <Fade in={!!targetId}>
              <Box sx={{ mt: 2 }}>
                <Autocomplete
                  options={destinationSections || []}
                  getOptionLabel={(o) => o.NOMBRE_SECCION || ""}
                  loading={loadingDestSections}
                  value={destinationSections?.find((s) => s.ID_SECCION === targetSectionId) || null}
                  onChange={(e, val) => setTargetSectionId(val?.ID_SECCION || "")}
                  renderInput={(params) => (
                    <TextField {...params} label="Sección Destino" size="small" />
                  )}
                />
              </Box>
            </Fade>
          )}

          <Button
            fullWidth
            variant="contained"
            onClick={onConfirm}
            disabled={isConfirmDisabled}
            sx={{ mt: 3, py: 1.5, fontWeight: 600, borderRadius: "8px" }}
          >
            {loadingFlex || loadingMassive ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Confirmar Copia"
            )}
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default FlexibleTab;